import { APIS } from "../../../_config";
import { CallApi } from "../callApi";

export interface Country {
  id: number;
  name: string;
  country_code: string;
  created_at: string;
  updated_at: string;
}

export interface CountryFormData {
  name: string;
  // country_code: string;
}

export function useCountryApi() {
  // List countries
  const getCountryList = async (params: any = {}): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.COUNTRY.COUNTRIES, params, true);
    return response;
  };

  // Get single country by UUID
  const getCountryById = async (id: string): Promise<any> => {
    const response = await CallApi.GET(APIS.LOCATION_SETTINGS.COUNTRY.DETAIL(id), {}, true);
    return response;
  };

  // Create country
  const createCountry = async (data: CountryFormData): Promise<any> => {
    const response = await CallApi.POST(APIS.LOCATION_SETTINGS.COUNTRY.COUNTRIES, data, true);
    return response;
  };

  // Update country
  const updateCountry = async (id: string, data: CountryFormData): Promise<any> => {
    const response = await CallApi.PUT(APIS.LOCATION_SETTINGS.COUNTRY.DETAIL(id), data, true);
    return response;
  };

  // Delete country
  const deleteCountry = async (id: string): Promise<any> => {
    const response = await CallApi.DELETE(APIS.LOCATION_SETTINGS.COUNTRY.DETAIL(id), true);
    return response;
  };

  return {
    getCountryList,
    getCountryById,
    createCountry,
    updateCountry,
    deleteCountry,
  };
}